module.exports = __webpack_public_path__ + "static/jff-0bba9b379a9c008077e6194c463e714d.png";